// (() => {
//   if (customElements.get('product-selector')) {
//     return;
//   }

//   class ProductSelector extends HTMLElement {
//     constructor() {
//       super();
//       this.form = this.querySelector('form');
//       if (this.form === null) return;

//       this.form.addEventListener(
//         'submit',
//         this.onSubmitHandler.bind(this)
//       );
//       this.submitButton = this.form.querySelector('[name="add"]');
//       this.cartDrawer = document.querySelector('cart-drawer');
//       this.variants = JSON.parse(
//         this.querySelector('[type="application/json"]').textContent
//       );
//       this.availableVariants = this.variants.filter(
//         variant => variant.available
//       );
//       this.unavailableText = ` - ${window.variantStrings.unavailable}`;
//       this.addEventListener('change', this.onVariantChange);

//       this.updateOptions();
//       this.updateVariant();

//       if (!this.currentVariant) {
//         console.log('!this.currentVariant');
//         return;
//       }

//       this.updateMedia();
//       this.setUnavailableOptions();
//     }

//     onSubmitHandler(event) {
//       event.preventDefault();

//       this.submitButton.classList.add('disabled');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];
//       const formData = new FormData(this.form);
//       if (this.cartDrawer) {
//         formData.append(
//           'sections',
//           this.cartDrawer
//             .getSectionsToRender()
//             .map(section => section.section)
//         );
//       }
//       formData.append('sections_url', window.location.pathname);
//       config.body = formData;

//       console.log('ITG Form Submit');
//       fetch(`${routes.cart_add_url}`, config)
//         .then(response => response.json())
//         .then(response => {
//           if (response.status) {
//             this.handleErrorMessage(response.description);
//             return;
//           }

//           if (
//             this.dataset.cartType == 'page' ||
//             Shopify.template == 'cart'
//           ) {
//             // window.location.reload();
//             window.location.href = '/cart';
//           } else if (this.dataset.cartType == 'drawer') {

//              //  var this_ = this;
//              // setTimeout(function () {
//                this.cartDrawer.renderContents(response);
//                 document.querySelector('#Product-Quickview-Modal[open]')?.hide();
//                 // window.location.href = window.location.pathname + '?open-cart-drawer';
               
//             // },4000)
            
//           }
//         })
//         .catch(error => {
//           console.error(error);
//         })
//         .finally(() => {
//           this.submitButton.classList.remove('disabled');
//         });
//     }

//     handleErrorMessage(errorMessage = false) {
//       const errorWrapper = this.querySelector('[data-error-wrapper]');
//       if (!errorWrapper) return;

//       errorWrapper.classList.toggle('hidden', !errorMessage);


//       if (typeof errorMessage === 'object') {
//         for (const [key, value] of Object.entries(errorMessage)) {
//           errorWrapper.textContent = `${key.charAt(0).toUpperCase() + key.slice(1)} ${value}`
//         }
//       } else {
//         errorWrapper.textContent = errorMessage || '';
//       }
//     }

//     onVariantChange(event) {
//       if (
//         event.target.type === 'number' ||
//         event.target.name.includes('selling_plan')
//       )
//         return;

      
//       // console.log(event);
//       // console.log(event.target.id);



//       // if (event.target.id.includes('ssdp__time-input-field-bloom_bloom')) {
//       //   return;
//       // }

//       // if (event.target.id === 'ssdp__time-input-field-bloom_bloom_GmaNjf') {
//       //  // return;
//       // }


//       if ($(event.target).parents('#infiniteoptions-container').length > 0) { 
//         console.log('ITG');
//          return;
//       } else {
//         console.log('ITG 2');
//       }

      
//       this.updateOptions();
//       this.updateVariant();
//       this.toggleAddButton(false, '');
//       this.handleErrorMessage();

//       if (!this.currentVariant) {
//         this.toggleAddButton(true, '');
//         this.setUnavailable();
//         return;
//       }

//       if (!this.currentVariant.available) {
//         ``;
//         this.toggleAddButton(true, window.variantStrings.soldOut);
//       }

//       this.updateMedia();
//       this.updateURL();
//       this.updateVariantInput();
//       this.renderProductInfo();
//       this.setUnavailableOptions();
//     }

//     updateOptions() {
//       this.options = Array.from(
//         this.querySelectorAll('input[type="radio"]:checked, select'),
//         el => ({ name: el.dataset.name, value: el.value })
//       );
//     }

//     updateVariant() {
//       this.currentVariant = this.options.length
//         ? this.variants.find(variant => {
//             return !variant.options
//               .map(
//                 (option, index) =>
//                   this.options[index].value === option
//               )
//               .includes(false);
//           })
//         : this.variants[0];
//     }

//     updateMedia() {
//       if (!this.currentVariant || !this.currentVariant.featured_media)
//         return;

//       const productMedia =
//         this.closest('[data-product]').querySelector('product-media');
//       productMedia.setActiveMedia(
//         this.currentVariant.featured_media.id
//       );
//     }

//     updateURL() {
//       if (!this.currentVariant || Shopify.template != 'product')
//         return;
//       const params = new URLSearchParams(window.location.search);
//       params[params.has('variant') ? 'set' : 'append'](
//         'variant',
//         this.currentVariant.id
//       );
//       window.history.replaceState(
//         {},
//         '',
//         `${this.dataset.url}?${params.toString()}`
//       );
//     }

//     updateVariantInput() {
//       const input = this.querySelector('[name="id"]');
//       input.value = this.currentVariant.id;
//     }

//     setUnavailable() {
//       const submitButton = this.querySelector('[name="add"]');
//       const price = this.querySelector(
//         `#price-${this.dataset.sectionId} .price`
//       );

//       if (!submitButton) return;
//       submitButton.textContent = window.variantStrings.unavailable;
//       if (price) price.classList.add('visibility-hidden');

//       Array.from(this.querySelectorAll('[data-size]')).map(x =>
//         x.removeAttribute('disable')
//       );
//       this.querySelector('[data-size]:checked').setAttribute(
//         'disable',
//         ''
//       );
//     }

//     toggleAddButton(disable, text) {
//       const submitButton = this.querySelector('[name="add"]');

//       if (!submitButton) {
//         return;
//       }

//       if (disable) {
//         submitButton.setAttribute('disabled', 'disabled');
//         if (text) submitButton.textContent = text;
//       } else {
//         submitButton.removeAttribute('disabled');
//         submitButton.textContent = window.variantStrings.addToCart;
//       }
//     }

//     renderProductInfo() {
//       const params = new URLSearchParams(window.location.search);
//       params[params.has('variant') ? 'set' : 'append'](
//         'variant',
//         this.currentVariant.id
//       );
//       params.append('section_id', this.dataset.sectionId);

//       fetch(`${this.dataset.url}?${params.toString()}`)
//         .then(response => response.text())
//         .then(responseText => {
//           const html = new DOMParser().parseFromString(
//             responseText,
//             'text/html'
//           );

//           if (html.querySelector('purchase-options')) {
//             this.querySelector('purchase-options').innerHTML =
//               html.querySelector('purchase-options').innerHTML;
//           }

//           if (
//             html.querySelector('[data-purchase-options-notification]')
//           ) {
//             this.querySelector(
//               '[data-purchase-options-notification]'
//             ).innerHTML = html.querySelector(
//               '[data-purchase-options-notification]'
//             ).innerHTML;
//           }

//           if (html.querySelector('[data-option-selected-value]')) {
//             this.querySelector(
//               '[data-option-selected-value]'
//             ).innerHTML = html.querySelector(
//               '[data-option-selected-value]'
//             ).innerHTML;
//           }

//           if (html.querySelector('[data-quantity-input]')) {
//             this.querySelector('[data-quantity-input]').innerHTML =
//               html.querySelector('[data-quantity-input]').innerHTML;
//           }

//           if (html.querySelector('[data-pickup-availability]')) {
//             this.querySelector(
//               '[data-pickup-availability]'
//             ).innerHTML = html.querySelector(
//               '[data-pickup-availability]'
//             ).innerHTML;

//             document.querySelector(
//               '#Pickup-Availability-Modal [role="dialog"]'
//             ).innerHTML = html.querySelector(
//               '[data-pickup-availability] [role="dialog"]'
//             )?.innerHTML;
//           }

//           const destinationPrice = document.querySelector(
//             `#price-${this.dataset.sectionId}`
//           );
//           const sourcePrice = html.querySelector(
//             `#price-${this.dataset.sectionId}`
//           );

//           if (destinationPrice && sourcePrice) {
//             destinationPrice.classList.remove('visibility-hidden');
//             destinationPrice.innerHTML = sourcePrice.innerHTML;
//           }
//         });
//     }

//     appendStringToElementHTML(el, string) {
//       if (el.innerHTML.includes(string)) return;
//       el.innerHTML = `${el.innerHTML}${string}`;
//     }

//     removeStringFromElementHTML(el, string) {
//       el.innerHTML = el.innerHTML.replace(string, '');
//     }

//     setUnavailableOptions() {
//       for (const [key, { name }] of this.options.entries()) {
//         const optionElements = this.querySelectorAll(
//           `[data-name="${name}"]`
//         );

//         optionElements.forEach(swatch => {
//           const selectOptions = swatch.querySelectorAll('option');
//           if (!selectOptions.length) {
//             return swatch.classList.toggle(
//               'is-unavailable',
//               !this.isOptionAvailable(key, swatch.value)
//             );
//           }

//           return selectOptions.forEach(option => {
//             if (this.isOptionAvailable(key, option.value)) {
//               return this.removeStringFromElementHTML(
//                 option,
//                 this.unavailableText
//               );
//             }

//             this.appendStringToElementHTML(
//               option,
//               this.unavailableText
//             );
//           });
//         });
//       }
//     }

//     isOptionAvailable(index, value) {
//       const currentHandle = `option${index + 1}`;
//       const valuesToCheck = {};

//       for (let i = 0; i < index; i++) {
//         const optionHandle = `option${i + 1}`;
//         const optionValue = this.options[i].value;
//         valuesToCheck[optionHandle] = optionValue;
//       }

//       valuesToCheck[currentHandle] = value;

//       return this.availableVariants.some(variant => {
//         return Object.entries(valuesToCheck).every(
//           ([handle, value]) => variant[handle] === value
//         ); 
//       });
//     }
//   }

//   customElements.define('product-selector', ProductSelector);


  

// // const urlParams = new URLSearchParams(window.location.search);
// // if (urlParams.has('open-cart-drawer')) {
// //     // Trigger click on the element with class 'cart-drawer'
// //     const cartDrawer = document.querySelector('#cart-counter[data-cart-link]');
// //     if (cartDrawer) {
// //       cartDrawer.click();
// //         ///cartDrawer.style.display = 'block'; // Show cart drawer or trigger your click event here
// //     }
    
// //     // Remove the 'open-cart-drawer' parameter from the URL
// //     const newUrl = window.location.pathname;
// //     history.replaceState(null, '', newUrl);
// // }



  
// })();

/* ==== AMBER + DPO VARIANT & PRICE FIX v2 ==== */
(function () {
  if (window.__amberVariantFixAppliedV2) return;
  window.__amberVariantFixAppliedV2 = true;

  var selectorEl = document.querySelector('product-selector');
  if (!selectorEl) return;

  var sectionId = selectorEl.dataset.sectionId;
  var baseUrl = selectorEl.dataset.url || window.location.pathname;

  // Leemos las variantes desde el <script type="application/json"> dentro del product-selector
  var variants = [];
  var jsonScript = selectorEl.querySelector('script[type="application/json"]');
  if (jsonScript) {
    try {
      variants = JSON.parse(jsonScript.textContent);
    } catch (e) { }
  }

  // Fallback a window.meta.product.variants por si acaso
  if ((!variants || !variants.length) && window.meta && meta.product && Array.isArray(meta.product.variants)) {
    variants = meta.product.variants;
  }
  if (!variants || !variants.length) return;

  function getForm() {
    return document.querySelector('form.product__form');
  }

  function getIdInput() {
    var form = getForm();
    return form ? form.querySelector('input[name="id"]') : null;
  }

  // Lee las opciones seleccionadas (Size, Color, etc.) del bloque .product__selector
  function getCurrentOptions() {
    var opts = [];

    // 1) Radios con data-position (tus swatches de talla)
    selectorEl
      .querySelectorAll('.product__selector input[type="radio"][data-position]:checked')
      .forEach(function (el) {
        var pos = Number(el.getAttribute('data-position'));
        if (!pos) return;
        var val = (el.getAttribute('data-value') || el.value || '').trim();
        if (val) opts[pos - 1] = val;
      });

    // 2) Selects (por si hubiera otras opciones en selector tipo <select>)
    selectorEl
      .querySelectorAll('.product__selector select')
      .forEach(function (sel) {
        if (!sel.options.length) return;
        var optEl = sel.options[sel.selectedIndex];
        if (!optEl) return;
        var pos = Number(optEl.getAttribute('data-position'));
        if (!pos) return;
        var val = (optEl.getAttribute('data-value') || optEl.value || '').trim();
        if (val) opts[pos - 1] = val;
      });

    // 3) Botones con aria-pressed (por si el tema usa este estilo)
    selectorEl
      .querySelectorAll('.product__selector [data-position][data-value][aria-pressed="true"]')
      .forEach(function (el) {
        var pos = Number(el.getAttribute('data-position'));
        if (!pos) return;
        var val = (el.getAttribute('data-value') || '').trim();
        if (val) opts[pos - 1] = val;
      });

    return opts;
  }

  // Busca la variante en el array "variants" que coincida con esas opciones
  function findVariantFromOptions(optionValues) {
    if (!optionValues || !optionValues.length) return null;

    var normalized = optionValues.map(function (v) {
      return v && v.toString().trim().toLowerCase();
    });

    return variants.find(function (v) {
      for (var i = 0; i < normalized.length; i++) {
        var wanted = normalized[i];
        if (!wanted) continue; // si no tenemos valor para esa posición, la ignoramos

        // Algunas tiendas tienen v.options[], otras solo option1/option2/option3
        var fromArray = Array.isArray(v.options) ? v.options[i] : null;
        var fromKeys = v['option' + (i + 1)];
        var candidate = fromArray || fromKeys;
        if (!candidate) return false;

        if (candidate.toString().trim().toLowerCase() !== wanted) {
          return false;
        }
      }
      return true;
    }) || null;
  }

  function getPriceTargets() {
    var byId = document.getElementById('price-' + sectionId);
    if (byId) return [byId];
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-product-price], .product__price')
    );
  }

  function fetchPriceHTML(variantId) {
    var url =
      baseUrl +
      (baseUrl.indexOf('?') === -1 ? '?' : '&') +
      'variant=' +
      encodeURIComponent(variantId) +
      '&section_id=' +
      encodeURIComponent(sectionId);

    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return (
          tmp.querySelector('#price-' + sectionId) ||
          tmp.querySelector('[data-product-price]') ||
          tmp.querySelector('.product__price')
        );
      });
  }

  var lastVariantId = null;
  var debounceTimer = null;

  function scheduleUpdate() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runUpdate, 60);
  }

  async function runUpdate() {
    var idInput = getIdInput();
    if (!idInput) return;

    var optionValues = getCurrentOptions();
    var variant = findVariantFromOptions(optionValues);
    if (!variant || !variant.id) {
      // console.log('No se encontró variante para', optionValues);
      return;
    }

    var variantId = String(variant.id);

    // 1) Actualizar input hidden "id" (lo que realmente se manda al carrito)
    if (idInput.value !== variantId) {
      idInput.value = variantId;
      try {
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {
        var ev = document.createEvent('Event');
        ev.initEvent('change', true, true);
        idInput.dispatchEvent(ev);
      }
    }

    // 2) Actualizar precio solo si cambió la variante
    if (lastVariantId === variantId) return;
    lastVariantId = variantId;

    try {
      var fresh = await fetchPriceHTML(variantId);
      if (fresh) {
        getPriceTargets().forEach(function (t) {
          t.innerHTML = fresh.innerHTML;
        });
      }
    } catch (e) {
      // console.warn('Fallo al actualizar el precio', e);
    }
  }

  // Escuchamos clicks/cambios dentro del product-selector (swatches, selects, etc.)
  selectorEl.addEventListener('click', function (e) {
    if (e.target.closest('.product__selector')) scheduleUpdate();
  });

  selectorEl.addEventListener('change', function (e) {
    if (e.target.closest('.product__selector')) scheduleUpdate();
  });

  // Por si otros scripts cambian atributos/clases sin disparar eventos
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'attributes' || m.type === 'childList') {
        scheduleUpdate();
        break;
      }
    }
  });
  mo.observe(selectorEl, { childList: true, subtree: true, attributes: true });

  // Sincronización inicial
  scheduleUpdate();
})();




